import { render, staticRenderFns } from "./ArchivesViewer.vue?vue&type=template&id=dc7b44f6&scoped=true&"
import script from "./ArchivesViewer.vue?vue&type=script&lang=js&"
export * from "./ArchivesViewer.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesViewer.vue?vue&type=style&index=0&id=dc7b44f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7b44f6",
  null
  
)

export default component.exports